<template>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card :loading="loading">
        <v-card-title class="headline">
            <i class="fa fa-info-circle colorInfo" aria-hidden="true"></i> 
            <v-card-title>{{ heading }}</v-card-title>
        </v-card-title>
        <v-card-text>{{ text }}</v-card-text>
        <v-text-field
          v-model="password"
          filled
          label="Contraseña"
          type="password"
        />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="hasDismissButton && !loading" text @click="dismiss()">Cancelar</v-btn>
          <v-btn v-else-if="loading" text>Cancelar</v-btn>
          <v-btn v-if="!loading" text @click="confirm()">Aceptar</v-btn>
          <v-btn v-else text>Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
/* eslint-disable no-console */
import Firebase from 'firebase/app'
import { Auth } from '../firebase/auth';

  export default {
    data: function () {
        return {
            dialog : false,
            loading : false,
            hasDismissButton : true,
            type: '',
            heading : 'Autenticación',
            title : '',
            text : 'Vuelva a iniciar sesión',
            password: '',
            token: undefined,
            onConfirm : () => { return new Promise(resolve => { resolve(); })},
            onDismiss : () => { return new Promise(resolve => { resolve(); })},
        }
    },
    watch: {
    },
    methods : {
        show(
                onConfirm = () => { return new Promise(resolve => { resolve(); })},
                onDismiss = () => { return new Promise(resolve => { resolve(); })},
            )
        {
            this.onConfirm = onConfirm;
            this.onDismiss = onDismiss;
            this.dialog = true;
        },

        async confirm() {
            this.loading = true;
            // Obtenemos el credencial y continuamos
            let user = await Auth.getCurrentUser();

            const credential = await Firebase.auth.EmailAuthProvider.credential(
                user.email,
                this.password
            );

            await this.onConfirm(credential);
            this.loading = false;
            this.dialog = false;
        },
        
        async dismiss() {
            this.loading = true;
            await this.onDismiss();
            this.loading = false;
            this.dialog = false;
        },

        close() {
            this.dialog = false;
        }
    }
  }
</script>